import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "快速入口",
    links: [
      { label: "用户登录", href: "/login" },
      { label: "申请注册", href: "/register" },
      { label: "找回密码", href: "/forgot-password" },
    ],
  },
  {
    title: "功能模块",
    links: [
      { label: "AI 智能问答", href: "/workbench/ai-chat" },
      { label: "智能文档生成", href: "/workbench/doc-gen" },
      { label: "文件管理", href: "/workbench/files" },
    ],
  },
  {
    title: "技术支持",
    links: [
      { label: "使用手册", href: "/manual" },
      { label: "系统公告", href: "#" },
      { label: "隐私政策", href: "#" },
    ],
  },
];

export default function HomeFooter() {
  return (
    <footer className="bg-[#1A2B3C] text-white">
      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://public.readdy.ai/ai/img_res/a84828b1-10f3-4f8c-851b-b2f4fe56a73c.png"
                alt="协和医疗"
                className="h-8 w-auto brightness-0 invert"
              />
              <span className="font-semibold text-white text-sm">协和医疗全域AI系统</span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs mb-6">
              部署于企业内网的智能知识管理平台，仅限授权人员访问，保障医疗数据安全合规。
            </p>
            <div className="flex gap-3">
              {["ri-mail-line", "ri-phone-line", "ri-map-pin-line"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 hover:bg-[#0EA5A0] transition-colors"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Links Columns */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-white font-semibold text-sm mb-5">
                <a href="#">{group.title}</a>
              </h4>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-white/50 text-sm hover:text-[#0EA5A0] transition-colors"
                      rel={link.href === "#" ? "nofollow" : undefined}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            © 2026 协和医疗 · 内部系统 · 版权所有
          </p>
          <p className="text-white/40 text-xs">
            技术支持：协和医疗信息技术部
          </p>
        </div>
      </div>
    </footer>
  );
}
